export function loadScript({
  src,
  onLoad,
  onError,
}: {
  src: string;
  onLoad: () => void;
  onError: () => void;
}): void {
  const script = document.createElement("script");
  script.src = src;
  script.type = "text/javascript";
  script.onload = onLoad;
  script.onerror = onError;
  const head = document.getElementsByTagName("head")[0];
  head.appendChild(script);
}

export const loadScriptPromise = (function () {
  let promisesBySrc = {};
  const fn = (src: string): Promise<void> => {
    if (promisesBySrc[src]) {
      return promisesBySrc[src];
    } else {
      const promise = new Promise<void>((resolve, reject) => {
        loadScript({
          src,
          onLoad: () => resolve(),
          onError: () => reject(),
        });
      });

      promisesBySrc[src] = promise;
      return promise;
    }
  };
  return fn;
})();
